const initState = {
  campaign_id: null
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  initHasPlanState(state) {
    for (const key in initState) {
      state[key] = initState[key]
    }
  },
  getCampaignId(state, data) {
    state.campaign_id = data
    console.log(state.campaign_id, '我是campaign_id')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
